import React, { useState, useEffect } from 'react';
import GameSlider from './GameSlider';
import { useAuth } from '../context/AuthContext';
import { usePayment } from '../context/PaymentContext';
import { useTranslation } from 'react-i18next';

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

const GameCollections = ({ loading: externalLoading = false }) => {
    const [collections, setCollections] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { isAuth } = useAuth();
    const { isBalanceLoaded, isCurrencyLoaded } = usePayment();
    const { t } = useTranslation();

    useEffect(() => {
        // Загружаем подборки только когда контексты полностью готовы
        if (isAuth ? (isBalanceLoaded && isCurrencyLoaded) : true) {
            fetchCollections();
        }
    }, [isAuth, isBalanceLoaded, isCurrencyLoaded]); // Перезагружаем при изменении авторизации и готовности контекстов

    const fetchCollections = async () => {
        try {
            setLoading(true);
            // Используем единый эндпоинт без параметров для получения коллекций с играми
            const response = await fetch(`${API_URL}/api/collections`, {
                credentials: 'include' // Для получения истории игр авторизованных пользователей
            });

            const data = await response.json();

            if (data.success) {
                setCollections(data.collections);
            } else {
                setError('Ошибка при загрузке подборок игр');
            }
        } catch (err) {
            console.error('Ошибка при загрузке подборок:', err);
            setError('Ошибка при загрузке подборок игр');
        } finally {
            setLoading(false);
        }
    };

    if (loading || externalLoading) {
        return (
            <div className="game-collections-loading">
                <div className="loading-spinner"></div>
                <div className="loading-text">Загрузка подборок игр...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="game-collections-error">
                <div className="error-text">{error}</div>
            </div>
        );
    }

    // Порядок отображения подборок
    const collectionsOrder = ['history', 'popular', 'new', 'slots', 'live', 'fast'];

    return (
        <div className="game-collections">
            {collectionsOrder.map(collectionType => {
                const collection = collections[collectionType];

                // Не показываем пустые подборки если они не должны отображаться
                if (!collection || (!collection.show_if_empty && (!collection.games || collection.games.length === 0))) {
                    return null;
                }

                return (
                    <GameSlider
                        key={collectionType}
                        title={collection.titleKey || collection.title}
                        games={collection.games}
                        collectionType={collectionType}
                    />
                );
            })}
        </div>
    );
};

export default GameCollections; 